import React from "react";
import useEventInfo from "gatsby-plugin-hfn-profile/components/PnrSummary/useEventInfo";
import { compareDateWithCurrentDate } from "sites-common/utils/FormatDate";
import { Image } from "theme-ui";

import { StaticImage } from "gatsby-plugin-image";
import appIcons from "sites-common/utils/icons";
import { Accordion, Modal } from "react-bootstrap";
import Seo from "../../../../components/seo";
import Layout from "../../../../layout";
import "../../../../assets/styles/special_event.scss";
import SpecialEventBanner from "../../../../components/special-event/SpecialEventBanner";
import ExploreKanha from "../../../../components/special-event/ExploreKanha";
import DaajiMessageInner from "../../../../components/special-event/DaajiMessageInner";
import Heartintune from "../../../../components/special-event/Heartintune";

import {
  bhandaraSept,
  styleProp,
} from "../../../../assets/data/bandaraRegistration";

const SpecialEventRegistration = () => {
  return (
    <div className="special_event_registration" id="register_event">
      <div className="flower_left">
        <StaticImage
          src="../../../../../../static/special-event/5.png"
          alt="banner"
          placeholder="blurred"
        />
      </div>
      <div className="flower_right">
        <StaticImage
          src="../../../../../../static/special-event/4.png"
          alt="banner"
          placeholder="blurred"
        />
      </div>
      <div className="container">
        <div className="row content_wrapper">
          <div className="col-lg-6 col-md-12">
            <p>Dear ones,</p>
            <p>
              I am delighted to invite you all to join the celebrations for the
              67th birthday of our beloved Pujya Daaji, on 27, 28 and 29
              September 2022 at Kanha Shanti Vanam. Please plan your travel
              accordingly. Details of registration, accommodation, group
              meditation timings and logistics are available on the Heartfulness
              app.
            </p>
            <p>
              You may also start planning any local celebrations in your centers
              accordingly.
            </p>
            <p>
              With love and respect,
              <br />
              <span className="author">Uma Shankar Bajpai </span>
              <br />
              <span className="author">General Secretary </span>
              <br />
              <span className="author">Shri Ram Chandra Mission</span>
            </p>
            <a
              href="https://cdn-prod.heartfulness.org/e-magazines/English/Kanha%20Layout%20Complete%20(3)%20(1).pdf"
              target="_blank"
              rel="noreferrer"
              className="navigation_map"
            >
              Navigation map within Kanha
            </a>
          </div>
          <div className="registerCardWrapper col-lg-5 col-md-12" />
        </div>
      </div>
    </div>
  );
};

SpecialEventRegistration.defaultProps = {
  customConfig: null,
};

const SpecialEvent2 = () => {
  const { customConfig, data } = useEventInfo(bhandaraSept);
  const checkDate = data?.reg_ends
    ? compareDateWithCurrentDate(data.reg_ends)
    : false;

  const [modalShowAudio, setModalShowAudio] = React.useState(false);
  const [modalShowVideo, setModalShowVideo] = React.useState(false);
  const [videoLink, setVideoLink] = React.useState("");
  const [audioLink, setAudioLink] = React.useState("");

  const listen = (language) => {
    setModalShowAudio(true);
    const link =
      customConfig?.daajiMessageAudio?.find(
        (item) => item?.language === language
      )?.link || "#";
    // setVideoType(type);
    setAudioLink(link);
  };

  const downloadPdf = (language) => {
    const link =
      customConfig?.daajiMessage?.find((item) => item?.language === language)
        ?.link || "#";
    const a = document.createElement("a");
    a.target = "_blank";
    a.href = link;
    a.click();
  };

  const view = (language) => {
    const link =
      customConfig?.daajiMessageHtml?.find(
        (item) => item?.language === language
      )?.link || "#";
    const a = document.createElement("a");
    a.target = "_blank";
    a.href = link;
    a.click();
  };

  const loadVideo = (language) => {
    setModalShowVideo(true);
    const link =
      customConfig?.daajiMessageVideo?.find(
        (item) => item?.language === language
      )?.link || "#";
    // setVideoType(type);
    setVideoLink(link);
  };

  const staticBannerContent = {
    title: "<h3>Coming together in Kanha</h3>",
    para: "<p>Join us with Daaji to celebrate Chariji`s birth anniversary</p>",
  };

  const bannerContent = customConfig?.bannerContent
    ? { ...staticBannerContent, ...customConfig.bannerContent }
    : staticBannerContent;

  return (
    <>
      <Seo
        title="Free Heartfulness Meditation Event | Daaji | Kanha Shanti Vanam"
        keyword="Heartfulness, Heartfulness Celebrations, Bhandara, Babuji Maharaj Birthday, April Bhandara, Kanha Shantivanam, Kanha Bhandara"
        description="Join Us Live Heartfulness Meditation Event with Daaji to Celebrate Babuji`s Birth Anniversary from Apr 29 to 1 May 2022 at Kanha Shanti Vanam. Register Now!"
      />
      <Layout isSticky wrapperClass="special_event">
        <div>
          <SpecialEventBanner
            eventId={bhandaraSept}
            styleProp={styleProp}
            bannerContent={bannerContent}
            data={data}
            customConfig={customConfig}
          />
          <SpecialEventRegistration
            eventId={bhandaraSept}
            styleProp={styleProp}
            endDate={checkDate}
            data={data}
          />
          <div className="daaji_wrrapper">
            <div className="container">
              {customConfig?.daajiMessage &&
              customConfig?.daajiMessage.length > 0 ? (
                <div className="daaji_box">
                  <h2>
                    <span>Daaji&apos;s Message</span>
                  </h2>
                  <p className="text-center">
                    Daaji is releasing the celebration message before the event,
                    so that we have the opportunity beforehand to reflect on how
                    to lead a life in tune with the message being shared. It is
                    available in many languages to download, Listen, View and
                    Watch.
                  </p>
                  <h6 className="mb-4">
                    Choose your Language:
                    <br />
                  </h6>
                  <div className="primary-language-wr">
                    {customConfig?.daajiMessage
                      .filter(function _(message) {
                        return message.primary;
                      })
                      .map(function _(item) {
                        const audioAvailable =
                          customConfig?.daajiMessageAudio?.find(
                            (messageItem) =>
                              item?.language === messageItem?.language
                          )?.link || "";
                        const videoAvailable =
                          customConfig?.daajiMessageVideo?.find(
                            (messageItem) =>
                              item?.language === messageItem?.language
                          )?.link || "";
                        const htmlAvailable =
                          customConfig?.daajiMessageHtml?.find(
                            (messageItem) =>
                              item?.language === messageItem?.language
                          )?.link || "";
                        const pdfAvailable =
                          customConfig?.daajiMessage?.find(
                            (messageItem) =>
                              item?.language === messageItem?.language
                          )?.link || "";
                        return (
                          <div className="primary-language">
                            <div className="language">{item.language}</div>
                            {htmlAvailable && (
                              <div
                                role="button"
                                tabIndex={0}
                                className="primary-language-btn"
                                onClick={() => {
                                  view(item.language);
                                }}
                                onKeyDown={() => {
                                  view(item.language);
                                }}
                              >
                                View
                              </div>
                            )}
                            {audioAvailable && (
                              <div
                                role="button"
                                tabIndex={0}
                                className="primary-language-btn"
                                onClick={() => {
                                  listen(item.language);
                                }}
                                onKeyDown={() => {
                                  listen(item.language);
                                }}
                              >
                                Listen
                              </div>
                            )}
                            {videoAvailable && (
                              <div
                                role="button"
                                tabIndex={0}
                                className="primary-language-btn"
                                onClick={() => {
                                  loadVideo(item.language);
                                }}
                                onKeyDown={() => {
                                  loadVideo(item.language);
                                }}
                              >
                                Watch
                              </div>
                            )}
                            {pdfAvailable && (
                              <div
                                role="button"
                                tabIndex={0}
                                className="primary-language-btn"
                                onClick={() => {
                                  downloadPdf(item.language);
                                }}
                                onKeyDown={() => {
                                  downloadPdf(item.language);
                                }}
                              >
                                Download
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                </div>
              ) : (
                <div className="daaji_box">
                  <h2>
                    <span>Daaji&apos;s Message</span>
                  </h2>
                  <div className="text-center">
                    Daaji will release a message during the celebrations that
                    will be available here in many languages.
                  </div>
                </div>
              )}
            </div>
          </div>

          {customConfig?.daajiMessage &&
          customConfig?.daajiMessage.length > 0 ? (
            <DaajiMessageInner eventInfo={customConfig?.daajiMessage || []} />
          ) : (
            <div />
          )}

          {customConfig?.addToCalendar?.dates &&
            customConfig.addToCalendar?.dates.length > 0 && (
              <div className="calander-wr my-4 pb-4 pt-2">
                <Accordion className="custom-acccordion" defaultActiveKey="0">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header className="accord-custom-head">
                      Add to calendar
                    </Accordion.Header>
                    <Accordion.Body className="text-start">
                      <ul>
                        {customConfig.addToCalendar?.dates.map((item) => (
                          <li className="calander-list">
                            <span className="day-wr">
                              {item?.day}
                              <span className="date-wr">{item?.time}</span>
                            </span>
                            {item?.gCalendarLink && (
                              <a
                                href={item?.gCalendarLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Image
                                  src={appIcons.googleCalendar}
                                  alt="g-calendar"
                                />{" "}
                                Google Calendar
                              </a>
                            )}
                            {item?.msCalendarLink && (
                              <a
                                href={item?.msCalendarLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Image
                                  src={appIcons.outlookCalendar}
                                  alt="ms-calendar"
                                />
                                Microsoft Outlook
                              </a>
                            )}
                            {item?.macCalendarLink && (
                              <a
                                href={item?.macCalendarLink}
                                target="_blank"
                                rel="noreferrer"
                              >
                                <Image src={appIcons.mac} alt="mac-calendar" />
                                Mac
                              </a>
                            )}
                          </li>
                        ))}
                      </ul>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            )}

          <ExploreKanha />
          <Heartintune />
        </div>
        <Modal
          show={modalShowAudio}
          onHide={() => setModalShowAudio(false)}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Daaji&apos;s Message
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="video">
              <audio controls>
                <source src={audioLink} type="audio/mpeg" />
                <track kind="captions" srcLang="en" label="english_captions" />
              </audio>
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          show={modalShowVideo}
          onHide={() => setModalShowVideo(false)}
          aria-labelledby="contained-modal-title-vcenter"
          centered
          dialogClassName="video-modal-90w"
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              Daaji&apos;s Message
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="video text-center">
              <video width="100%" height="" controls>
                <source src={videoLink} type="video/mp4" />
                <track kind="captions" srcLang="en" label="english_captions" />
              </video>
            </div>
          </Modal.Body>
        </Modal>
      </Layout>
    </>
  );
};

export default SpecialEvent2;
